import ReactDOM from 'react-dom';
// scroll bar
import 'primeicons/primeicons.css';
import { PrimeReactProvider } from 'primereact/api';
import 'primeflex/primeflex.css';
import 'primereact/resources/primereact.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'simplebar/src/simplebar.css';

import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import './i18n';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ----------------------------------------------------------------------

ReactDOM.render(
  <PrimeReactProvider>
    <HelmetProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </HelmetProvider>
  </PrimeReactProvider>,
  document.getElementById('root')
);

// ✅ Register Firebase Messaging Service Worker (for push notifications)
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register(`${process.env.PUBLIC_URL}/firebase-messaging-sw.js`)
    .then((registration) => {
      console.log('✅ Firebase Service Worker registered successfully:', registration);
    })
    .catch((err) => {
      console.log('❌ Firebase Service Worker registration failed:', err);
    });
}

// (Optional) Performance measurement
reportWebVitals();
